import { Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lib-pagination',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PaginationComponent implements OnChanges {

  @Input() itemsCount!: number;
  @Input() activePage?: number;
  @Input() pageLength = 10;
  @Input() advanced = false;

  @Output() pageChange: EventEmitter<number>;


  p?: number;

  protected pages: number[] = [];

  constructor() {
    this.pageChange = new EventEmitter<number>();
  }

  ngOnChanges(): void {
    this.buildPagination();
    this.activePage = parseInt(this.activePage.toString())
    this.p = this.activePage;
  }

  private buildPagination(): void {
    let pagesCount = this.itemsCount / this.pageLength;
    pagesCount = Math.floor(pagesCount);
    if (this.itemsCount % this.pageLength > 0) {
      pagesCount++;
    }
    this.pages = Array(pagesCount).fill(1).map((x, i) => i + 1);
  }

  page(pageNum: number): void {
    this.activePage = pageNum;
    this.p = this.activePage;
    this.pageChange.emit(this.activePage);
  }

  prev(): void {
    const prevPage = this.activePage - 1;
    if (prevPage < 1) {
      return;
    }
    this.activePage = prevPage;
    this.p = this.activePage;
    this.pageChange.emit(this.activePage);
  }

  next(): void {
    const nextPage = this.activePage + 1;
    if (nextPage > this.pages.length) {
      return;
    }
    this.activePage = nextPage;
    this.p = this.activePage;
    this.pageChange.emit(this.activePage);
  }

  jumpToPage(e: KeyboardEvent): void {
    const key = e.key;
    if (key == 'Enter') {
      this.jumpToPageBlur();
    }
  }

  jumpToPageBlur(): void {
    if (this.p > this.pages.length || this.p == undefined || this.p < 1) {
      return;
    }
    this.page(parseInt(this.p.toString()));

  }

}
